module.exports = __webpack_public_path__ + "fonts/fa-solid-900.f6121be5.woff2";